import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useDataSave, {DataSaveType} from "../../core/services/query/hooks/useDataSave";
import useCacheRemove from "../../core/services/query/hooks/useCacheRemove";

export interface AddRoomInput {
    prebookingId?: string;
    prebooking: string | null;
    roomHotelEvent: string;
    hotelEvent?: string;
    arrivalDate?: string;
    departureDate?: string;
    quantity: number;
    allowOverbooking: boolean;
}

export default function useAddRoom (): DataSaveType<AddRoomInput> {
    const client = useAPIClient();
    client.onError(error => {
        throw error;
    });
    const removeCache = useCacheRemove();

    return useDataSave<AddRoomInput>(
        input => client.post("prebookings/" + input.prebookingId + "/rooms", input),
        {
            onSuccess: () => removeCache("basket-count"),
        }
    );
}